import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import { DishFullInfoContext, IDishFullInfoContext } from '../../../../../../../dishFullInfoState/dishFullInfoContext';

const ExternalIdField: React.FC = () => {
	const { dishForFullInfo } = useContext<IDishFullInfoContext>(DishFullInfoContext);

	return <FullInfoField label="externalIdLabel" value={dishForFullInfo?.externalId} />;
};

export default ExternalIdField;
